import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BASE_URL } from "../../App";
import axios from 'axios';
import Swal from 'sweetalert2';
import ExcelFileData from '../SolarExcelFile/ExcelTemplate.xlsx';
import * as XLSX from "xlsx";

// ANT DESIGN IMPORTS
import { Divider, Input, Button, Typography, Spin, message, Upload } from "antd";
import { DownloadOutlined, InboxOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { Dragger } = Upload

export default function EnquiryCalls() {

    const username = localStorage.getItem('USER_ID');
   
    const navigate = useNavigate();

     useEffect(() => {

    if(username == null){
        navigate('/');
    }

  }, []);

    const [loading, setLoading] = React.useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [UploadExcelFile, setUploadExcelFile] = useState([]);

    const ExcelUpload = {
        onRemove: (file) => {
            setUploadExcelFile([]);
            const index = UploadExcelFile.indexOf(file);
            const newFileList = UploadExcelFile.slice();
            newFileList.splice(index, 1);
            setUploadExcelFile(newFileList);
            AlertMsg("info", "file Removed successfully", 2);
        },
        beforeUpload: (file) => {
            setUploadExcelFile([]);
            const index = UploadExcelFile.indexOf(file);
            const newFileList = UploadExcelFile.slice();
            newFileList.splice(index, 1);
            setUploadExcelFile(newFileList);

            setUploadExcelFile([file]);
            AlertMsg("success", "file Ready To Upload.!", 2);
            return false;
        },
        UploadExcelFile,
    };

    const AlertMsg = (type, msg, duration) => {
        messageApi.open({
            type: type,
            content: msg,
            duration: duration,
        });
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = ExcelFileData;
        link.download = 'ExcelTemplate.xlsx';
        link.click();
      };
	  
	  
	  const handleDownloadExcel = async () => {
    setLoading(true);
    try {
        // Make an API call to fetch the data
        const response = await axios.get("https://mobile.cri.in/others/cri_retailer/public/api/customer_data_excel_downloade"); // Use await here

        // Extract data from response
        const data = response.data.data;

        // Convert the JSON data into a worksheet
        const ws = XLSX.utils.json_to_sheet(data);

        // Create a new workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Create a file and trigger the download
        XLSX.writeFile(wb, "CustomerFullData.xlsx");
    } catch (error) {
        console.error("Error downloading data:", error);
    } finally {
        setLoading(false);  // Set loading to false after the process is complete
    }
};
	  

    const SubmitBTNClick = () => {
        setLoading(true);
		
		if(username == null){
        navigate('/');
    }
		
		
        const formData = new FormData();
        UploadExcelFile.forEach((file) => {
            formData.append('ExcelFile', file);
            formData.append('username', username);
        });

        axios.post('https://mobile.cri.in/others/cri_retailer/public/api/ExcelUpload', formData)
            .then(response => {
                Swal.fire({
                    icon: "success",
                    text: "Excel Uploaded Successfully.!"
                });
            }).catch(error => {
                Swal.fire({
                    icon: "warning",
                    title: error.response.data.message,
                    text: error.response.data.ApplicationNo,
                    willOpen: () => {
                        const titleElement = Swal.getTitle();
                        titleElement.style.fontSize = '16px';
                        titleElement.style.fontWeight = 'bold';

                        const popupElement = Swal.getPopup();
                        const textElement = popupElement.querySelector('.swal2-html-container');
                        if (textElement) {
                            textElement.style.fontSize = '16px';
                            textElement.style.fontWeight = 'bold';
                        }
                    }
                });
            }).finally(() => {
                setLoading(false);
            });

    }

   


    return (
        <>
            {contextHolder}
            <Spin size="large" spinning={loading}>
                <div className='m-4'>
                    <center><h5><b><u>Customer Data Upload</u></b></h5></center>
                    <div style={{ float: 'right' }} className='mt-2'>
                        <Button
                            style={{
                                backgroundColor: '#20a757',
                                borderColor: '#20a757',
                                color: '#fff',
                                borderRadius: '20px',
                                width: '100%',
                            }}
                            onClick={handleDownload}
                            icon={<DownloadOutlined />}
                        >
                            <b>Download Excel Template</b>
                        </Button>
                    </div>
                    <br />
                    <br />
                    <div className="">
                        <Dragger {...ExcelUpload}>
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">Click or drag the EXCEL file to this area to upload.</p>
                            <p className="ant-upload-hint">
                                Support for single or bulk file uploads. Please do not upload the same file repeatedly.
                            </p>
                        </Dragger>
                        <br />
                        <Button
                            style={{
                                backgroundColor: '#1677ff',
                                borderColor: '#1677ff',
                                color: '#fff',
                                borderRadius: '20px',
                                width: '100%',
                            }}
                            icon={<DownloadOutlined />}
                            onClick={SubmitBTNClick}
                        >
                            <b>Submit</b>
                        </Button>
                    </div>
					
					<br />
                    <br />
					<div className='text-center'>
					  <button className='btn btn-success btn-lg' onClick={handleDownloadExcel} disabled={loading}>
						{loading ? "Downloading..." : "Download Data as Excel"}
					  </button>
					</div>
                </div>
            </Spin>
        </>
    );
}
